import _ from 'lodash';
import Vue from 'vue';

export default {
  state: {
    menu: {
      //TODO: Cambiar
      servidor:'Tecnosis',
      //servidor: 'Teleperformance',
      opcion: {
        name: 'General',
        icon: 'fas fa-home',
      },
      tokenGenerico: '',
      tokenRefresh: '',
      token: '',
      tokenfcm: '',
      tokenmsal: '',
      supervisor: '',
      usuario: {}
    }
  },
  mutations: {
    setOpcion(state, opcion) {
      state.menu.opcion.name = opcion;
    },
    setUsuario(state, usuario) {
      state.usuario = usuario;
      state.menu.usuario = usuario;
    },
    setTokenMsal(state, token) {
      state.menu.tokenmsal = token;
      localStorage.setItem('tokenmsal', token);
    },
    setTokenGenerico(state, token) {
      state.menu.tokenGenerico = token;
    },
    setTokenRefresh(state, token) {
      state.menu.tokenRefresh = token.jwt;
      state.menu.supervisor = token.esSupervisor
      localStorage.setItem('tp_refresh_token', token.jwt);
    },
    setToken(state, token) {
      state.token = token;
      state.menu.token = token;

      localStorage.setItem('apiKey_tp', token);
    },
    setInterceptorToken(state, data) {
      if (data && !_.isNil(_.get(data, 'token', undefined))) {
        Vue.http.interceptor.before = (request) => {
          if (data && data.token) {
            request.headers.set('Authorization', 'Bearer ' + data.token);
            request.headers.set('Accept', 'application/json');
          }
        };
      } else {
        Vue.http.interceptor.before = (request) => { };
      }
    }
  },
  actions: {
    Definir_Opciones_Menu_Lateral({ commit, state }, usuario) {

    },
    Actualizar_Usuario({ commit, state }, data) {
      commit('setUsuario', data);
    },
    Actualizar_TokenMsal({ commit, state }, token) {
      commit('setTokenMsal', token);
    },
    Actualizar_TokenGenerico({ commit, state }, token) {
      commit('setTokenGenerico', token);
    },
    Actualizar_TokenRefresh({ commit, state }, token) {
      commit('setTokenRefresh', token);
    },
    Actualizar_Token({ commit, state }, token) {
      commit('setToken', token);
    },
    Asignar_Interceptor_Token({ commit, state }, token) {
      commit('setInterceptorToken', token);
    }
  },
  getters: {
    getMenu(state) {
      return state.menu;
    }
  },

}
